import { t } from "@/global";
import { ModalForm, ProFormItem, ProFormTextArea } from "@ant-design/pro-form";
import { ActionType } from "@ant-design/pro-table";
import { Checkbox, message } from "antd";
import { useEffect, useState } from "react";

type SetNoteProps = {
  visible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  actionRef: React.MutableRefObject<ActionType | undefined>;
  guids: string[];
  setFunction: (guids: string[], note: string) => Promise<void>;
}

const SetNoteModal: React.FC<SetNoteProps> = (props) => {
  const [removeNote, setRemoveNote] = useState(false);

  useEffect(() => {
    if (props.visible) {
      setRemoveNote(false);
    }
  }, [props.visible]);

  const handleUpdate = async (data: any) => {
    const hide = message.loading('Updating');
    try {
      let note: string;
      if (removeNote) {
        note = '';
      } else {
        note = data.note || '';
      }
      await props.setFunction(props.guids, note);
      hide();
      message.success('Updated successfully');
      return true;
    } catch (error) {
      hide();
      message.error(
        typeof error == 'string' ? (error as string) : 'Update failed, please try again!',
      );
      return false;
    }
  };

  return (
    <ModalForm
      title={t('set_note', true)}
      width="400px"
      open={props.visible}
      onOpenChange={props.setModalVisible}
      onFinish={async (values) => {
        const success = await handleUpdate(values);
        if (success) {
          if (props.actionRef.current) {
            props.actionRef.current?.reloadAndRest?.();
          }
          props.setModalVisible(false);
        }
      }}
      preserve={false}
      modalProps={{
        maskClosable: false,
        destroyOnClose: true,
        onCancel: () => {
          props.setModalVisible(false);
        },
      }}
    >
      {!removeNote && <ProFormTextArea
        name="note"
        label={t('Note', true)}
        width="md"
        rules={[
          {
            max: 300,
            required: true,
            whitespace: true,
          }
        ]}
      />}
      <ProFormItem>
        <Checkbox checked={removeNote} onChange={(e) => setRemoveNote(e.target.checked)}>
          {t('remove_note', true)}
        </Checkbox>
      </ProFormItem>
    </ModalForm>
  )
}

export default SetNoteModal;

